import * as React from "react";
import Payment from "./Payment";
import Customer from "./Customer";
import {Field, Form} from "react-final-form";
import Loader from "./Loader";

class Order extends React.Component {

	render() {

		const orderSubmit = (submitting) => {
			return submitting ? <Loader/> : (<button id="gt3" type="submit">Submit</button>)
		}

		return (
			<div>
				<Form
					onSubmit={this.props.order}
					initialValues={this.props.customer.profile}
					render={({handleSubmit, reset, submitting, pristine, values}) => (
						<form id="chargeForm" name="chargeForm" onSubmit={handleSubmit}>
							<div className="form-box">
								<Customer/>
								<Payment profiles={this.props.customer.billing}/>
							</div>

							<div className="row">
								<div className="col-sm-12">
									<div id="errors">
										<div>{this.props.orderError}</div>
									</div>
									<p>
										<label id="terms-label" htmlFor="terms">
											<Field
												name="terms"
												component="input"
												type="checkbox"
												required
											/>
											I agree to the
											<a href="https://accounts.ultimateprospector.com/default/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions and Privacy Policy</a> for this purchase.
										</label>
									</p>
									<p className="emph small">
										<strong>Secure:</strong> Transaction details are encrypted for your
										protection.
									</p>
									{orderSubmit(submitting)}
								</div>
							</div>
						</form>
					)}
				/>
			</div>

		)
	}
}

export default Order;


// WEBPACK FOOTER //
// ./src/components/Order.jsx